import React from 'react';

import withAppState from '../mobx/withAppState'

import Numpad from './Numpad';
import Loading from './Loading';

class TablePicker extends React.Component {
  constructor(props) {
    super(props);

    let comingSoon = false;
    
    if (!!this.props.restaurant)
      comingSoon = this.props.restaurant.comingSoon === true;
    else
      comingSoon = true;

    this.state = {
      comingSoon,
      comingSoonContent: null,
      tableValue: this.props.tableNumber,
      data: null,
    };
  }

  async componentDidMount() {
    if (this.state.comingSoon === true) {
      this.props.setLoading(true);
      const response = await fetch(`api/Restaurant/GetComingSoonContent`);
      this.props.setLoading(false);
      if (response.status === 200) {
        let data;
        try {
          data = await response.json()
        } catch (err) {
          console.error(err);
        }
        this.setState({
          comingSoonContent: data
        });
      }
    }
  }

  pressNumkey(value) {
    const result = this.state.tableValue * 10 + value;
    if (result < 1000) {
      this.setState({ tableValue: result });
    }
  }

  pressDelKey() {
    const result = Math.floor(this.state.tableValue / 10);
    this.setState({ tableValue: result });
  }

  render() {
    return (
      <main className="table-picker">
        {this.state.comingSoon === true ? (
          !!this.state.comingSoonContent ? (
            <div>
              <h2>{this.state.comingSoonContent.comingSoonPayAtTableTitle}</h2>
              <p>{this.state.comingSoonContent.comingSoonPayAtTableContent}</p>
            </div>
          ) : null
        ) : (
            <div>
              <h2
                className="table-picker-selected"
                value={this.state.tableValue}
                style={
                  this.state.tableValue === 0
                    ? { fontSize: '3rem' }
                    : { '': '' }
                }
              >
                {this.state.tableValue === 0
                  ? 'Table No.'
                  : this.state.tableValue}
              </h2>
              <Numpad
                pressNumkey={value => this.pressNumkey(value)}
                pressDelKey={() => this.pressDelKey()}
                pressEnterKey={() => this.props.pressEnterKey(this.state.tableValue)}
              />
              <div className="table-number-message">
                <p>
                  Can't find your table number?
                <br />
                Please ask your waiting staff.
              </p>
              </div>
            </div>
          )}
        {this.props.loading === true && (
          <div role="loading" className="loading-container">
            <Loading />
          </div>
        )}
      </main>
    );
  }
}

export default withAppState(TablePicker,
  {
    mobXProps: ({
      tableNumber,
      restaurant,
    }) => ({
      tableNumber,
      restaurant,
    }),
    mobXActions: ({
      selectTableNumber,
      setErrorModalMessage,
    }) => ({
      selectTableNumber,
      setErrorModalMessage,
    })
  }
);